import { createLogic } from 'redux-logic';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// feature dispatch-detail
import {
  createTelRateActionRequest,
  updateTelRateActionRequest,
  createTelCarrierRateActionRequest,
  updateTelCarrierRateActionRequest } from './actions';
//////////////////////////////////////////////////

const isInvalidTelCarrierRate = (values) => {
  const { carrierRateCharges } = values;
  const carrierMainChargeTotal = G.getChargeTotalFromCharges(
    carrierRateCharges,
    GC.CHARGE_TYPE_MAIN,
  );
  if (G.isNilOrEmpty(carrierMainChargeTotal)) {
    G.showToastrMessageSimple(
      'info',
      G.getWindowLocale('messages:provide-main-change-for-carrier', 'Please, provide Main Charge'),
    );
    return true;
  }
  return false;
};

const handleCreateTelRateRequest = createLogic({
  type: createTelRateActionRequest,
  validate({ getState, action }, allow, reject) {
    const values = action.payload;

    if (G.isInvalidDriverRate(values)) return reject();

    allow(action);
  },
});

const handleUpdateTelRateRequest = createLogic({
  type: updateTelRateActionRequest,
  validate({ getState, action }, allow, reject) {
    const values = action.payload;

    if (G.isInvalidDriverRate(values)) return reject();

    allow(action);
  },
});

const handleCreateCarrierTelRateRequest = createLogic({
  type: [
    createTelCarrierRateActionRequest,
    updateTelCarrierRateActionRequest,
  ],
  validate({ getState, action }, allow, reject) {
    if (isInvalidTelCarrierRate(action.payload)) return reject();
    allow(action);
  },
});

export default [
  handleCreateTelRateRequest,
  handleUpdateTelRateRequest,
  handleCreateCarrierTelRateRequest,
];
